import { IneligibilityReason as OfferIneligibilityReason } from '@ocx/graphql';

import { PurchaseVoucherOffer } from './offer.types';

export type PurchaseIneligibilityReason = 'not_enough_points' | 'purchasable_eligibility_constraint_failed';

export type CanVoucherBePurchasedResult =
  | { canPurchase: true }
  | { canPurchase: false; reasons: PurchaseIneligibilityReason[] };

export const canVoucherBePurchased = (
  offer: PurchaseVoucherOffer,
  context: { membershipPoints: number },
): CanVoucherBePurchasedResult => {
  const reasons: PurchaseIneligibilityReason[] = [];

  if (offer.earningMechanism.fulfilmentPrice > context.membershipPoints) {
    reasons.push('not_enough_points');
  }

  if (offer.ineligibilityReason === OfferIneligibilityReason.PurchasableEligibilityConstraintFailed) {
    reasons.push('purchasable_eligibility_constraint_failed');
  }

  return reasons.length ? { canPurchase: false, reasons } : { canPurchase: true };
};
